import React from "react";
import { Link } from "react-router-dom";

function NotFound({ message = "Page not found" }) {
  return (
    <section className="jh-container jh-section">
      <h1 className="jh-title">{message}</h1>
      <p className="jh-sub">
        Try returning to the <Link to="/">home page</Link>.
      </p>
    </section>
  );
}

export default NotFound;
